<template>
    <div class="panel">
        <div class="row">
            <h1 class="public-header">You are now logged in</h1>
        </div>
        <div class="public-description">
            <div class="row">
                <div class="col-12">
                    If you would like to receive future security codes via SMS/Text message then please
                    enter your mobile number below.
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <amf-format-input label="My Mobile Number" :columns="6" v-model="mobilePhone" format="(___) ___-____" placehold="(___) ___-____" />
        </div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-public btn-block" @click.prevent="setMfaMethod('phone')">Save</button>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="pull-right">
                    <a style="font-size: 0.9rem" href="#" @click.prevent="setMfaMethod('email')">I will use email for codes</a>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {
        props: {
            uid: { type: String },
            mfaResult: { type: Object }
        },
        data() {
            return {
                mobilePhone: null
            }
        },
        methods: {
            async setMfaMethod(method) {
                var api = Axios.create({
                    baseURL: romeApi.baseURL,
                    headers: {
                        Authorization: `Bearer ${this.mfaResult.access_token}`,
                    }
                });
                
                try {
                    await api.post(`user/profile/${this.uid}/mfa-method`, { method, mobilePhone: this.mobilePhone });
                    toastService.success('Your two-factor authentication preference has been updated');
                    this.$emit('mfa-complete');
                }
                catch(e) {
                    if(e.response && e.response.data && e.response.data.ErrorMessage) {
                        toastService.error(e.response.data.ErrorMessage);
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/framework/MfaAskForMethod.vue